//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "toptextdownpic",
    props: ['background_image', 'content']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/player/page/toptextdownpic.vue
// module id = 55
// module chunks = 0